export { default as Services } from './Services';


// WEBPACK FOOTER //
// ./src/components/Services/index.jsx